import React from 'react';

import { attemptLogin } from 'RLX/State/Auth/AuthActions';
import { loadSite } from 'RLX/State/Content/ContentActions';

import AuthFormController from 'RLX/Controllers/AuthFormController';

class LoginForm extends AuthFormController {
  getFields () {
    const { email, pass } = this.state;
    const { handleEmailChange, handlePassChange } = this;
    return [
      {
        label: 'Email',
        icon: 'envelope-open',
        value: email,
        onChange: handleEmailChange,
        type: 'text',
        required: true,
        validate: 'email'
      },
      {
        label: 'Password',
        secret: true,
        icon: 'key',
        value: pass,
        onChange: handlePassChange,
        type: 'text',
        required: true,
        validate: 'pass'
      }
    ];
  }

  getButtons () {
    return [
      {
        url: '/RLX/register',
        iconSide: 'right',
        text: 'Register',
        icon: 'motorcycle',
        className: 'subtle'
      },
      {
        submit: true,
        iconSide: 'right',
        text: 'Login',
        icon: 'lock',
        when: this.isSubmittable()
      }
    ];
  }

  handleSubmit ({ email, pass }) {
    attemptLogin({ email, pass })
      .then(res => loadSite());
  }
};

export default LoginForm;



// WEBPACK FOOTER //
// ./client/RLX/Views/Auth/Forms/LoginForm.jsx